import { createContext, type ReactNode, useContext, useState } from "react";
import { createPortal } from "react-dom";

/** The controls row's end, null until it mounts; undefined outside a controls row. */
const ActionsSlot = createContext<HTMLElement | null | undefined>(undefined);

/**
 * The row of controls above a chart, then the chart. A chart in `children` puts its own actions at
 * the row's end through `ChartAction`.
 */
export function ChartControls({
  controls,
  children,
}: {
  controls: ReactNode;
  children: ReactNode;
}) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <ActionsSlot value={slot}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        {controls}
        <div ref={setSlot} className="ml-auto flex items-center gap-2 empty:hidden" />
      </div>
      {children}
    </ActionsSlot>
  );
}

/** An action for the chart's controls row, or in place for a chart without one. */
export function ChartAction({ children }: { children: ReactNode }) {
  const slot = useContext(ActionsSlot);
  if (slot === undefined) return children;
  return slot && createPortal(children, slot);
}
